import React from "react";

/**
 * Bootstrap alert. theme prop maps to alert-{theme}.
 * open/toggle props allow dismissible behaviour.
 */
const Alert = ({ theme = "primary", open = true, toggle, className = "", style, children, ...rest }) => {
  if (!open) return null;

  const cls = [
    "alert",
    `alert-${theme}`,
    toggle && "alert-dismissible fade show",
    className,
  ].filter(Boolean).join(" ");

  return (
    <div className={cls} role="alert" style={style} {...rest}>
      {children}
      {toggle && (
        <button type="button" className="close" onClick={toggle} aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      )}
    </div>
  );
};

export default Alert;
